import {getDeviceType} from "../../utils/versionUtils"

interface DeviceSymbolProps {
	softwareVersion: string
}

export const DeviceSymbol = ({softwareVersion}: DeviceSymbolProps) => {
	const deviceType = getDeviceType(softwareVersion)

	switch (deviceType) {
		case "angel":
			return (
				<div className="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 rounded-full font-bold text-sm">
					A
				</div>
			)
		case "falcon":
			return (
				<div className="flex items-center justify-center w-8 h-8 bg-orange-100 dark:bg-orange-900/40 text-orange-600 dark:text-orange-300 rounded-full font-bold text-sm">
					F
				</div>
			)
		default:
			return (
				<div className="flex items-center justify-center w-8 h-8 bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 rounded-full font-bold text-sm">
					?
				</div>
			)
	}
}
